/**
 * AutryWidgetCalendar
 * inline calendar widget/datepicker
 */

// https://flatpickr.js.org/
import flatpickr from 'flatpickr'
import 'flatpickr/dist/themes/airbnb.css'

Drupal.behaviors.AutryWidgetCalendar = {
  attach: function (context, settings) {
    const elements = once(
      'AutryWidgetCalendar',
      '.autry-widget-calendar',
      context
    )
    elements.forEach(el => {
      const input = el.querySelector('input')
      const defaultDate = input.value || 'today'
      const today = new Date()

      this.calendar = flatpickr(input, {
        inline: true,
        monthSelectorType: 'static',
        dateFormat: 'Y-m-d',
        defaultDate, // https://stackoverflow.com/questions/66530283/expected-property-shorthand
        prevArrow: 'Previous',
        nextArrow: 'Next',
        onDayCreate: (dObj, dStr, fp, dayElem) => {
          // https://github.com/flatpickr/flatpickr/issues/1039
          // @TODO: "today" is marked as past!
          if (dayElem.dateObj < today) {
            dayElem.classList.add('past')
          }
        },
        onChange: (obj, str, instance) => {
          if (document.body.classList.contains('sb-show-main')) {
            console.log(`/events/calendar/${str}`)
            return false
          }
          window.location.href = `/events/calendar/${str}`
        }
      })
    })
  }
}
